module.exports = "/images/alert-info.svg?3c2009a34215a1091a54761dc1ea8b74";